'use strict';

module.exports = {
    loadFloatingLabel: function () {
        var selector = '.form-control-label';
        var $labels = $(selector);
        var $fields = $labels.map(function (i, label) {
            var $field = $('#' + label.getAttribute('for'));
            return $field.attr('placeholder') ? null : $('#' + label.getAttribute('for'));
        });

        if (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)) {
            $('input:-webkit-autofill').each(function (i, field) {
                var $label = $(selector).filter('[for="' + $(field).attr('id') + '"]');
                $label.addClass('form-control-label--float-up');
            });
        }

        $fields.each(function (i, field) {
            // initialize focus/blur event handlers for inputs with labels
            $(field).on('focusin change', function () {
                var $label = $(selector).filter('[for="' + this.getAttribute('id') + '"]');
                if (!($label.hasClass('form-control-label--float-up'))) {
                    $label.addClass('form-control-label--float-up');
                }
            });

            $(field).on('focusout', function () {
                if ($(this).val()) {
                    return;
                }
                var $label = $(selector).filter('[for="' + this.getAttribute('id') + '"]');
                $label.removeClass('form-control-label--float-up');
            });

            // make label float if there is any auto-filled form content on page load
            if ($(field).val() || ($(field).get(0) === document.activeElement)) {
                var $label = $(selector).filter('[for="' + this.attr('id') + '"]');
                $label.addClass('form-control-label--float-up');
            }
        });
    },
    refreshFloatingLabels: function () {
        var $labels = $('.form-control-label');
        var $fields = $labels.map(function (i, label) {
            var $field = $('#' + label.getAttribute('for'));
            return $field.attr('placeholder') ? null : $('#' + label.getAttribute('for'));
        });
        $fields.each(function (i, field) {
            var $label = $('.form-control-label').filter('[for="' + this.attr('id') + '"]');
            if ($(field).val() || ($(field).get(0) === document.activeElement)) {
                $label.addClass('form-control-label--float-up');
            } else {
                $label.removeClass('form-control-label--float-up');
            }

            try {
                if ($(field).is(':-webkit-autofill')) {
                    $label.addClass('form-control-label--float-up');
                }
            } catch (e) {
                window.console.error('Unsupported pseudo: -webkit-autofill');
            }
        });
    }
};

$('body').find('.form-control-dropdown').click(function () {
    $(this).siblings('.icon').toggleClass('show');
});

$(document).on('click', function (e) {
    if ($(e.target).closest('.form-control-dropdown').length === 0) {
        $('.icon').removeClass('show');
    }
});
